import { useEffect, useId, useState } from 'react';

const codes = product => [product.mk_barcode, ...[product.barcode].flat(), product.product_code].filter(Boolean).map(String);
const label = product => [product.product_name_eng || product.product_name_tel || product.product_code,
  product.brand_name_english || product.brand_name_englishh || product.brand_name_telugu || product.brand_name,
  `${product.quantity || 1} ${product.unit_short_code || product.unit_name || ''}`, [...new Set(codes(product))].join(' / ')].filter(Boolean).join(' · ');

export default function PurchaseProductSearch({ products, value, onChange }) {
  const listId = useId();
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  useEffect(() => { if (!value && !open) setQuery(''); }, [value, open]);
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const matches = products.filter(product => {
    const text = `${label(product)} ${product.product_name_tel || ''}`.toLowerCase();
    return terms.every(term => text.includes(term));
  }).sort((a, b) => Number(codes(b).includes(query.trim())) - Number(codes(a).includes(query.trim())));
  const suggestions = matches.slice(0, 50);
  const select = product => { onChange(String(product.id)); setQuery(label(product)); setOpen(false); };
  return <div className="relative min-w-0 max-w-full flex-1" onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }}>
    <input role="combobox" aria-label="New product to add to purchase order" aria-autocomplete="list"
      aria-expanded={open} aria-controls={listId} aria-activedescendant={open && suggestions[active] ? `${listId}-${active}` : undefined}
      value={query} placeholder="Search product name, brand or barcode" autoComplete="off"
      onFocus={() => { setOpen(true); setActive(0); }}
      onChange={event => { onChange(''); setQuery(event.target.value); setOpen(true); setActive(0); }}
      onKeyDown={event => {
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault(); setOpen(true);
          setActive(previous => Math.max(0, Math.min(suggestions.length - 1, previous + (event.key === 'ArrowDown' ? 1 : -1))));
        }
        if (event.key === 'Enter') { event.preventDefault(); if (open && suggestions[active]) select(suggestions[active]); }
      }} className="w-full rounded border px-3 py-2" />
    {open && <div className="absolute bottom-full z-50 mb-1 max-h-64 w-full overflow-auto rounded border bg-white shadow-lg">
      <ul id={listId} role="listbox" aria-label="Product suggestions">
        {suggestions.map((product, index) => <li key={product.id} id={`${listId}-${index}`} role="option" aria-selected={index === active}
          onMouseDown={event => event.preventDefault()} onMouseEnter={() => setActive(index)} onClick={() => select(product)}
          className={`cursor-pointer px-3 py-2 text-left text-sm ${index === active ? 'bg-blue-100' : 'hover:bg-blue-50'}`}>{label(product)}</li>)}
      </ul>
      {!suggestions.length && <p role="status" className="p-3 text-sm text-gray-500">No matching products.</p>}
      {matches.length > 50 && <p className="p-2 text-xs text-gray-500">Showing 50 matches. Keep typing to narrow the search.</p>}
    </div>}
  </div>;
}
